module.exports = __webpack_public_path__ + "static/media/refresh-page-option.f8db7744.png";